import Vue from 'vue'
import VueRouter from 'vue-router'
import ParkoverView from '../views/ParkOverView.vue'
import ParkEnergyView from '@/views/ParkEnergyView'
import ParkSecurityView from '@/views/ParkSecurityView'
import DeviceManagementView from '@/views/DeviceManagementView'
Vue.use(VueRouter)

const routes = [
  {
    path: '/parkOver',
    name: 'parkOver',
    component: ParkoverView
  },
  {
    path: '/parkEnergy',
    name: 'parkEnergy',
    component: ParkEnergyView
  },
  {
    path: '/parkSecurity',
    name: 'parkSecurity',
    component: ParkSecurityView
  }, {
    path: '/deviceManagement',
    name: 'deviceManagement',
    component: DeviceManagementView
  }
]

const router = new VueRouter({
  routes
})

export default router
